// @ts-check
import { Box, Flex, Text, Title } from '~/design-system';
import { Field } from 'formik';

export default function ReadyCheckboxField({
  name,
  id = name,
  disabled = false,
  showCheckbox = true,
  children,
  count = 0,
}) {
  return (
    <Flex align="center" sx={{ height: 50 }}>
      <Field
        id={id}
        name={name}
        type="checkbox"
        disabled={disabled}
        sx={{ ...(!showCheckbox && { display: 'none' }) }}
      />
      <Box
        sx={{
          marginRight: 3,
          textAlign: 'right',
          width: '100px',
          height: '36px',
          display: 'table',
        }}
      >
        <Title
          sx={{ display: 'table-cell', verticalAlign: 'middle' }}
          variant="small"
        >
          {count}
        </Title>
      </Box>
      <Box sx={{ width: '300px', height: '36px', display: 'table' }}>
        <Text
          variant="smallest"
          sx={{ display: 'table-cell', verticalAlign: 'middle' }}
        >
          {children}
        </Text>
      </Box>
    </Flex>
  );
}
